import { gql } from '@apollo/client';

export default gql`
  query getAffiliate {
    affiliate {
      id
      name
      photo
      metadata {
        id
        name
        photo
      }
    }
  }
`;
